import React from 'react';
import { string, bool } from 'prop-types';
import Icon from '../../Icon/index';
import { Text } from '../../Text/index';

const currencyIconMap = currencyCode => {
  switch (currencyCode) {
    case 'GBP':
      return <Icon size="15" name="pound" />;
    case 'EUR':
      return <Icon size="15" name="euro" />;;
    case 'AUD': case 'NZD': case 'USD':
      return <Icon size="15" name="dollar" />;
    default:
      return false;
  }
};

const GetCurrencyIconImg = ({ currencyCode }) => {
  const icon = currencyIconMap(currencyCode);
  if (icon) return icon;
  return (
    <Text
      lineHeight={1.6}
      fontWeight="bold"
      fontSize="xsmall"
    >
      {currencyCode}
    </Text>
  );
};

export default GetCurrencyIconImg;

GetCurrencyIconImg.propTypes = {
  currencyCode: string.isRequired,
  useSymbol: bool,
};
